module.exports = __webpack_public_path__ + "static/media/content-marketing.da93f2ae.png";